import React, { useEffect } from "react";

import {
  TextField,
  Typography,
  Box
} from "@mui/material";

import {
  useForm
} from "react-hook-form";

function DepartmentForm({
  department,
  onSubmit
}) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  useEffect(() => {
    if (department) {
      reset({
        department_name: department.department_name,
        description: department.description
      });
    }
    else {
      reset({
        department_name: "",
        description: ""
      });
    }
  }, [department, reset]);

  return (
    <form
      id="department-form"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2.2
        }}
      >
        <Typography
          sx={{
            fontSize: 13,
            color: "#475569",
            fontWeight: 600,
            mb: 0.2
          }}
        >
          Department Information
        </Typography>

        <Box>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: "#334155",
              mb: 0.8
            }}
          >
            Department Name
          </Typography>

          <TextField
            fullWidth
            size="small"
            placeholder="Enter department name"
            error={Boolean(errors.department_name)}
            helperText={errors.department_name ? "Department name is required" : ""}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                background: "#ffffff"
              },
              "& .MuiFormHelperText-root": {
                minHeight: 20,
                mt: 0.7
              }
            }}
            {...register("department_name", { required: true })}
          />
        </Box>

        <Box>
          <Typography
            sx={{
              fontSize: 13,
              fontWeight: 700,
              color: "#334155",
              mb: 0.8
            }}
          >
            Description
          </Typography>

          <TextField
            fullWidth
            size="small"
            multiline
            rows={3}
            placeholder="Enter description"
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                background: "#ffffff"
              }
            }}
            {...register("description")}
          />
        </Box>
      </Box>
    </form>
  );
}

export default DepartmentForm;
